import { parseApiResponse, throwApiError } from '@/shared/utils/apiResponse';

/**
 * `parseApiResponse` já desembrulha o envelope `{ data }`; o `throwApiError` antes dele existe
 * só para o erro chegar na tela em pt-BR em vez do `HTTP <status>` genérico do shared.
 * Um `{ success: true }` sem `data` desembrulha para `undefined`, mas o overload usado promete
 * `T` — o compilador cala e o erro só apareceria como TypeError em quem lê o campo adiante.
 */
export const jsonOk = async <T>(response: Response, fallbackMsg: string): Promise<T> => {
  if (!response.ok) await throwApiError(response, fallbackMsg);
  const data = await parseApiResponse<T | undefined>(response);
  if (data === undefined) throw new Error(fallbackMsg);
  return data;
};
